import React from 'react';

export const HamburgerIcon = (props: any) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M22 0H0V2.3H22V0Z" />
      <path d="M22 9.8H0V12.1H22V9.8Z" />
      <path d="M22 19.7H0V22H22V19.7Z" />
    </svg>
  );
};
